import { Country } from 'common/src/constants/countries';
import { healZipPostalCodeValue } from 'common/src/transformers/healZipPostalCodeValue';
import { BillProcessingStatus } from 'common/src/types/enums/BillProcessingStatus';
import { Service } from 'common/src/types/enums/Service.enum';
import { IUtility } from 'common/src/types/interfaces';

import {
  autoCompleteType,
  patternInputType,
  selectInputType,
  textInputType,
} from 'portal/src/components/common/forms/FormFieldTypes';
import getInternalNotesField from 'portal/src/components/common/forms/internalNotesField';

export type UtilityFormValues = ReturnType<typeof defaultValues>;

export const defaultValues = (entity: Partial<IUtility> = {}) => ({
  address1: entity.billingAddress1 ?? '',
  address2: entity.billingAddress2 ?? '',
  city: entity.billingCity ?? '',
  postalCode:
    healZipPostalCodeValue(entity.billingPostalCode, entity.billingCountry) ??
    '',
  state: entity.billingState ?? '',
  country: (entity.billingCountry ?? '') as Country,
  billProcessingStatus:
    entity.billProcessingStatus ?? BillProcessingStatus.Provisional,
  description: entity.description ?? '',
  internalNotes: entity.internalNotes ?? '',
  name: entity.name ?? '',
  serviceTypes: entity.serviceTypes ?? [],
  vendorNumber: entity.vendorNumber ?? '',
  website: entity.website ?? '',
});

export const getFields = (hasSystemAdminAccess: boolean) => {
  const formFieldsConfiguration: (
    | autoCompleteType
    | patternInputType
    | selectInputType
    | textInputType
  )[] = [
    {
      placeholder: 'Utility Name',
      label: 'Utility Name',
      name: 'name',
      type: 'textInput',
      required: true,
    },
    {
      hidden: !hasSystemAdminAccess,
      label: 'Bill Processing Status',
      name: 'billProcessingStatus',
      placeholder: 'Bill Processing Status',
      required: true,
      type: 'selectInput',
      values: Object.values(BillProcessingStatus).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      placeholder: 'Vendor Number',
      label: 'Vendor Number',
      name: 'vendorNumber',
      type: 'textInput',
      required: false,
    },
    {
      placeholder: 'Service Types',
      label: 'Service Types',
      name: 'serviceTypes',
      type: 'selectInput',
      required: false,
      multiple: true,
      values: Object.values(Service).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      placeholder: 'Utility Website',
      label: 'Utility Website',
      name: 'website',
      type: 'textInput',
      required: false,
    },
    {
      placeholder: 'Utility Description',
      label: 'Utility Description',
      name: 'description',
      type: 'textInput',
      required: false,
      multiline: true,
    },
    getInternalNotesField(hasSystemAdminAccess),
  ];
  return formFieldsConfiguration;
};
